<template>
  <!-- eslint-disable max-len -->
  <main class="u-container">
    <h1 class="font-bold">
      USPS Change-of-Address<sup>®</sup>
    </h1>
    <ProgressBar
      v-if="!showChoiceExperience"
      :current="3"
      :steps="5"
      class="mt-8"
    >
      Step: 3 of 5
    </ProgressBar>
    <IndividualProgressBar
      v-if="showChoiceExperience"
      role="progressbar"
      :aria-valuenow="progressStep"
      :aria-valuemin="0"
      :aria-valuemax="1"
    />
    <form
      ref="form"
      novalidate
      class="mt-8"
      @submit.prevent="validate"
    >
      <h2 ref="stepHeading">
        <template v-if="!showChoiceExperience">
          Step 3:&nbsp;
        </template>
        <span class="font-bold">Date Of Birth</span>
      </h2>
      <p class="mt-4">
        For your security, we need to verify your identity. <span class="font-bold">Please enter your date of birth.</span>
      </p>
      <p class="relative flex align-items flex-wrap mt-2">
        <span class="age-verification__icon-lock" />
        <span class="ml-5">Your information is safe. We will never store your date of birth information. Read our</span>
        <a
          href="https://about.usps.com/who/legal/privacy-policy/full-privacy-policy.htm"
          rel="noopener noreferrer"
          target="_blank"
          class="c-link c-link--inline ml-1"
        >privacy policy</a>.
      </p>
      <div class="w-1/2 mt-6">
        <InputDropdown
          ref="month"
          v-model="month"
          label="Month"
          name="dob-month"
          :has-error="errors.dateOfBirth.hasError && !month"
          @input="analytics.input.month();"
        >
          <option value="">
            Month
          </option>
          <option
            v-for="({ name, num }) in months"
            :key="num"
            :value="num"
          >
            {{ name }}
          </option>
        </InputDropdown>
        <InputDropdown
          ref="day"
          v-model="day"
          label="Day"
          name="dob-day"
          class="mt-4"
          :has-error="errors.dateOfBirth.hasError && !day"
          @input="analytics.input.day();"
        >
          <option value="">
            Day
          </option>
          <option
            v-for="day in days"
            :key="day"
            :value="day"
          >
            {{ day }}
          </option>
        </InputDropdown>
        <InputDropdown
          ref="year"
          v-model="year"
          label="Year"
          name="dob-year"
          class="mt-4"
          :has-error="errors.dateOfBirth.hasError && !year"
          @input="analytics.input.year();"
        >
          <option value="">
            Year
          </option>
          <option
            v-for="year in years"
            :key="year"
            :value="year"
          >
            {{ year }}
          </option>
        </InputDropdown>
        <p
          v-if="errors.dateOfBirth.hasError"
          class="mt-4 text-sm font-bold text-red-200"
        >
          {{ errors.dateOfBirth.message }}
        </p>
      </div>
      <InputCheckbox
        ref="dobVerified"
        v-model="dobVerified"
        name="dob-verified"
        class="mt-6"
        @input="analytics.click.verifyCheckbox($event);"
      >
        I verify that the information above is correct to the best of my knowledge.
      </InputCheckbox>
      <p
        v-if="errors.dobVerified.hasError"
        class="mt-2 text-sm font-bold text-red-200"
      >
        {{ errors.dobVerified.message }}
      </p>
      <div class="flex items-center mt-6">
        <router-link
          id="back"
          ref="back"
          :to="{ name: 'verify-info-read' }"
          replace
          class="c-btn c-btn--secondary mr-6"
          @click.native="analytics.click.back();"
        >
          Back
        </router-link>
        <button
          id="next"
          ref="next"
          class="c-btn"
          @click="analytics.click.next();"
        >
          Next
        </button>
      </div>
    </form>
  </main>
</template>

<script>
import {
  InputCheckbox,
  InputDropdown,
  ProgressBar,
} from '@mgo/ui/lib/components';
import { desktopAnalytics } from './analytics';
import ageVerificationMixin from './mixin';
import IndividualProgressBar from '../../../../ui/lib/components/progress-bar/IndividualProgressBar.vue';

export default {
  name: 'AgeVerification',
  components: {
    InputCheckbox,
    InputDropdown,
    ProgressBar,
    IndividualProgressBar,
  },
  mixins: [ageVerificationMixin],
  computed: {
    showChoiceExperience: () => JSON.parse(sessionStorage.getItem('showChoiceExperience')),
    current() {
      return 3;
    },
    totalSteps() {
      return !this.showChoiceExperience ? 6 : 7;
    },
    progressStep() {
      return this.current / this.totalSteps;
    },
    analytics() {
      return desktopAnalytics();
    },
  },
};
</script>
